import { ShortName } from '@getaccept/shared-utils';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { State, UserMessage } from '../types/bank-id-sweden';
import { BankIdSeStatus } from '../../types/enums/bankid-se';

export class BankIdSwedenHelper {
  static getUserMessage(state: State, statusCode: ShortName): UserMessage {
    switch (state) {
      case 'cancelling':
        return {
          title: t('cr_bankid_cancelling'),
          description: t('cr_bankid_cancelling_description'),
        };

      case 'completed':
        return {
          title: t('bankid-is-signed'),
          description: t('you-will-soon-be-sent-to-next-step'),
        };
    }

    switch (statusCode) {
      case ShortName.RFA1:
        return { title: 'Start your BankID app', description: '' };
      case ShortName.RFA3:
        return { title: t('cr_action_cancelled'), description: t('please_try_again') };
      case ShortName.RFA4:
        return {
          title: t('cr_id_or_signing_in_progress'),
          description: t('cr_id_or_signing_in_progress_info'),
        };
      case ShortName.RFA5:
        return {
          title: t('cr_bankid_internal_error'),
          description: t('try_again_or_contact_support_with_link'),
        };
      case ShortName.RFA6:
        return { title: t('cr_action_cancelled'), description: t('cr_you_cancelled_the_action') };
      case ShortName.RFA8:
        return {
          title: t('cr_bankid_not_responding'),
          description: t('cr_bankid_not_responding_info'),
        };
      case ShortName.RFA9:
        return {
          title: t('cr_enter_security_code'),
          description: t('cr_enter_security_code_info'),
        };
      case ShortName.RFA1_13:
        return { title: t('cr_trying_to_start_your_bankid'), description: '' };
      case ShortName.RFA14_15:
        return { title: t('bankid_searching'), description: t('bankid_searching_description') };
      case ShortName.RFA16:
        return { title: t('cr_old_bankid'), description: t('cr_old_bankid_info') };
      case ShortName.RFA17:
        return {
          title: t('bankid_app_not_found'),
          description: t('bankid_app_not_found_description'),
        };
      case ShortName.RFA21:
        return { title: t('cr_bankid_process_in_progress'), description: t('please_wait') };
      case ShortName.RFA22:
      default:
        return {
          title: t('cr_bankid_unknown_error'),
          description: t('cr_error_msg_try_again_or_contact_sender'),
        };
    }
  }

  static getStateFromStatus(status: BankIdSeStatus, shortName: ShortName): State {
    switch (status) {
      case BankIdSeStatus.Pending:
        return [ShortName.RFA1, ShortName.RFA1_13].includes(shortName) ? 'started' : 'signing';
      case BankIdSeStatus.Failed:
        return 'failed';
      case BankIdSeStatus.Complete:
        return 'completed';
      default:
        return 'not_started';
    }
  }
}
